export enum EnumMes
{
    Janeiro = 1,
    Fevereiro,
    Marco,
    Abril,
    Maio,
    Junho,
    Julho,
    Agosto,
    Setembro,
    Outubro,
    Novembro,
    Dezembro
};

export const MesLista = [
    {
        value: EnumMes.Janeiro,
        label: "Janeiro"
    },
    {
        value: EnumMes.Fevereiro,
        label: "Fevereiro"
    },
    {
        value: EnumMes.Marco,
        label: "Marco"
    },
    {
        value: EnumMes.Abril,
        label: "Abril"
    },
    {
        value: EnumMes.Maio,
        label: "Maio"
    },
    {
        value: EnumMes.Junho,
        label: "Junho"
    },
    {
        value: EnumMes.Julho,
        label: "Julho"
    },
    {
        value: EnumMes.Agosto,
        label: "Agosto"
    },
    {
        value: EnumMes.Setembro,
        label: "Setembro"
    },
    {
        value: EnumMes.Outubro,
        label: "Outubro"
    },
    {
        value: EnumMes.Novembro,
        label: "Novembro"
    },
    {
        value: EnumMes.Dezembro,
        label: "Dezembro"
    }
];